import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { LoginPageComponent } from './login-page/login-page.component';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { CheckboxModule } from '../../shared/components/checkbox/checkbox.module';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppHttpInterceptor } from 'src/app/core/interceptors/AppHttpInterceptor';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [LoginPageComponent],
  providers: [HttpClient, { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true }],
  imports: [
    CommonModule,
    ButtonModule,
    InputModule,
    ReactiveFormsModule,
    CheckboxModule,
    HttpClientModule,
    TranslateModule,
    RouterModule
  ]
})
export class LoginPageModule {}
